import { MoovStepConfigurationDTO } from "./moovStepConfigurationDTO";

export class MoovConfigurationDTO{
    public id?:number;
    public moovDefinitionId!:number;
    public customerId!:number;
    public clientId?:number;
    public status!:number;
    public expectedFrequency?:string;
    public filenameStartsWith?:string;
    public filenameContains?:string;
    public stepConfigurations:MoovStepConfigurationDTO[]=[];
    public added?:string;
    public edited?:string;
    public deleted:boolean=false;
    public uniqueIdentifier?:string
    public presetValues?:string;
    public usagePriceOverride?:number;
}